import { render, staticRenderFns } from "./checkRoleDialog.vue?vue&type=template&id=0a4ef62f&scoped=true"
import script from "./checkRoleDialog.vue?vue&type=script&lang=js"
export * from "./checkRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./checkRoleDialog.vue?vue&type=style&index=0&id=0a4ef62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ef62f",
  null
  
)

export default component.exports